import Alpine from '../../../../../../../CodeQ.Site/Resources/Private/node_modules/alpinejs/dist/module.esm.js';

Alpine.data('docuwareFileViewer', (formSubmitUrl, categoriesUrl = null, options) => ({
    isLoading: false,
    latestRequestTime: null,
    searchTerm: '',
    category: '',
    dateFrom: new Date(options?.dateFrom ?? new Date().setFullYear(new Date().getFullYear() - 10)).toISOString(),
    dateTo: new Date(options?.dateTo ?? new Date()).toISOString(),
    categories: [],
    searchResults: {},
    page: 1,
    itemsPerPage: options?.itemsPerPage || 50,

    init () {
        const urlParams = new URLSearchParams(window.location.search);
        this.searchTerm = urlParams.get('file-viewer-search-term') || '';
        this.category = urlParams.get('file-viewer-search-category') || options?.category || '';

        if (categoriesUrl) {
            fetch(categoriesUrl)
                .then((response) => {
                    if (response.status === 200) {
                        return response.json();
                    } else {
                        throw new Error('The categories could not be loaded.');
                    }
                })
                .then((data) => {
                    this.categories = data;
                    this.category = urlParams.get('file-viewer-search-category') || '';
                })
                .catch((error) => {
                    alert('The categories could not be loaded. Please try again later.');
                    console.error(error);
                })
        }

        this.loadSearchResults();
        this.addArrows();
    },

    paginate(newPage) {
        this.page = newPage;
        this.loadSearchResults();
    },

    hasMorePages() {
        return this.searchResults.total > (this.page + 1) * this.itemsPerPage;
    },

    hasLessPages() {
        return this.page > 1;
    },

    setDateFrom(newDateFrom) {
        this.dateFrom = new Date(Date.parse(newDateFrom + 'T00:00:00Z')).toISOString();
    },

    setDateTo(newDateTo) {
        this.dateTo = new Date(Date.parse(newDateTo + 'T23:59:59Z')).toISOString();
    },

    loadSearchResults(e) {
        if (e) e.preventDefault();
        this.isLoading = true;

        const requestTime = Date.now();
        this.latestRequestTime = requestTime;

        fetch(formSubmitUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                searchTerm: this.searchTerm,
                category: this.category,
                dateFrom: this.dateFrom,
                dateTo: this.dateTo,
                start: (this.page - 1) * this.itemsPerPage,
                count: this.itemsPerPage,
            })
        })
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                } else {
                    throw new Error('The file results could not be loaded.');
                }
            })
            .then((data) => {
                if (this.latestRequestTime === requestTime) {
                    this.searchResults = data;
                    this.isLoading = false;
                }
            })
            .catch((error) => {
                this.isLoading = false;
                alert('The file results could not be loaded. Please try again later.');
                console.error(error);
            })
    },

    onSearchTermEnter($el) {
        let isMobile = window.innerWidth < 768;
        if (isMobile) {
            $el.blur();
            this.$root.querySelector('.docuware-file-viewer__results')?.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    },

    addArrows() {
        let figureWrapper = this.$root.querySelector('.docuware-file-viewer__figure-wrapper');
        let figure = this.$root.querySelector('.docuware-file-viewer__figure');
        if (!figure) return;

        // There is also DocumentFileViewer.List which does not use a table layout
        let scrollButtons = document.createElement('DIV');
        scrollButtons.classList.add('container__scroll-buttons');
        scrollButtons.innerHTML = `
            <button class="container__scroll-button container__scroll-button--left" id="scroll-left" aria-label="Scroll to left" title="Scroll left">
                Scroll left
            </button>
            <button class="container__scroll-button container__scroll-button--right container__scroll-button--is-available" id="scroll-right" aria-label="Scroll to right" title="Scroll right">
                Scroll right
            </button>`
        let scrollButtonsArray = Array.from(scrollButtons.querySelectorAll('button'));

        figureWrapper.append(scrollButtons);
        let buttonLeft = scrollButtons.querySelector('.container__scroll-button--left');
        let buttonRight = scrollButtons.querySelector('.container__scroll-button--right');

        scrollButtonsArray.forEach(element => {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                let type = 'left';
                if (e.target.classList.contains('container__scroll-button--right')) {
                    type = 'right';
                }

                figure.scrollTo({top: 0, left: figure.scrollLeft + window.innerWidth * (type === 'left' ? -1 : 1), behavior: 'smooth'});
            });
        });

        window.addEventListener('scroll', (e) => {
            if (!e.target.classList || !e.target.classList.contains('docuware-file-viewer__figure')) return;

            //buttons
            let containerRect = figure.getBoundingClientRect();
            let isEdgeLeft = figure.scrollLeft <= 10;
            let isEdgeRight = figure.scrollWidth - figure.scrollLeft - containerRect.width <= 10

            buttonLeft.classList[isEdgeLeft ? 'remove' : 'add']('container__scroll-button--is-available');
            buttonRight.classList[isEdgeRight ? 'remove' : 'add']('container__scroll-button--is-available');
        }, true);
    }
}));
